import React from "react";
import * as S from "./RouteInfo.styles";

export interface RouteInfoProps {
  title: string;
  routeInfo: Array<{ key: string; value: string }>;
}

export default function RouteInfo(props: RouteInfoProps) {
  const { title, routeInfo } = props;

  if (routeInfo?.length > 0) {
    return (
      <S.Wrapper>
        {title && <S.Title>{title}</S.Title>}
        <S.Table>
          <S.Header>
            <S.TableRow>
              <S.HeaderColumn>{routeInfo[0].key}</S.HeaderColumn>
              <S.HeaderColumn>{routeInfo[0].value}</S.HeaderColumn>
            </S.TableRow>
          </S.Header>
          <S.BodyWrapper>
            {routeInfo.slice(1).map((route, index) => {
              return (
                <S.TableRow key={index}>
                  <S.TitleColumn>{route.key}</S.TitleColumn>
                  <S.ValueColumn>{route.value}</S.ValueColumn>
                </S.TableRow>
              );
            })}
          </S.BodyWrapper>
        </S.Table>
      </S.Wrapper>
    );
  }
  return null;
}
